import { render, staticRenderFns } from "./EditCriteria.vue?vue&type=template&id=9edfbd68&scoped=true"
import script from "./EditCriteria.vue?vue&type=script&lang=js"
export * from "./EditCriteria.vue?vue&type=script&lang=js"
import style0 from "./EditCriteria.vue?vue&type=style&index=0&id=9edfbd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edfbd68",
  null
  
)

export default component.exports